var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profile)?_c('div',[_c('div',[_c('div',[_c('img',{attrs:{"src":_vm.profile.picture}})]),_c('div',[_c('h2',[_vm._v(_vm._s(_vm.profile.name))]),_c('p',[_vm._v(_vm._s(_vm.profile.email))])])]),_c('div',[_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.profile, null, 2)))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }